import { Percent } from 'lucide-react';
import { CollectionAdmin } from './_P1Common';

export default function AdminPromoCodes() {
  return (
    <CollectionAdmin
      path="promo-codes"
      title="Promotivni kodovi"
      subtitle="Kodovi za popust pri pretplati"
      icon={Percent}
      testid="admin-promo-codes"
      fields={[
        { key: 'code', label: 'Kod' },
        { key: 'discount_pct', label: 'Popust (%)', type: 'number' },
        { key: 'max_uses', label: 'Max broj korištenja', type: 'number' },
        { key: 'expires_at', label: 'Vrijedi do (ISO datum)' },
        { key: 'active', label: 'Aktivan', type: 'checkbox' },
        { key: 'note', label: 'Bilješka', type: 'textarea' },
      ]}
    />
  );
}
